import { useEffect } from 'react'
import { motion, useAnimationControls } from 'framer-motion'
import { ShoppingBag } from 'lucide-react'
import { useUIStore } from '@/stores/uiStore'

/**
 * The bag glyph that gives a quick bounce each time an item is added. The
 * animation is driven by `bagPulse` in the UI store (incremented by the
 * add-to-bag actions) rather than by cart count, so removing an item never
 * plays the "added" feedback.
 */
export function BagIcon() {
  const pulse = useUIStore((s) => s.bagPulse)
  const motionReduced = useUIStore((s) => s.motionReduced)
  const controls = useAnimationControls()

  useEffect(() => {
    if (pulse === 0 || motionReduced) return
    controls.start(
      { scale: [1, 1.3, 0.88, 1], rotate: [0, -10, 8, 0] },
      { duration: 0.5, ease: 'easeOut' }
    )
  }, [pulse, motionReduced, controls])

  return (
    <motion.span animate={controls} className="inline-flex origin-bottom">
      <ShoppingBag className="h-[18px] w-[18px]" />
    </motion.span>
  )
}